import { useQuery } from '@tanstack/react-query';

import { transformDataBuilderResults } from '../datasets/api-transform';
import { fetchDataBuilderResults } from './data-builder-api';

const DATA_BUILDER_QUERY_KEY = ['data-builder'] as const;

export const useDataBuilderQuery = () =>
  useQuery({
    queryKey: DATA_BUILDER_QUERY_KEY,
    queryFn: fetchDataBuilderResults,
    select: transformDataBuilderResults,
  });

export const useDataBuilderSchema = () =>
  useQuery({
    queryKey: DATA_BUILDER_QUERY_KEY,
    queryFn: fetchDataBuilderResults,
  });
